import { useContext, useEffect, useMemo } from 'react'
import Box from '@mui/material/Box'
import { OnboardingContext } from '../../context/onboarding/OnboardingContext'
import useOnboardingSteps from '../../lib/useOnboardingSteps'
import Section from './Section'
import { Button } from '@mui/material'
import { Logger } from '@wolfdanepug/common-react'
import { useNavigate } from 'react-router'

export interface NavigationProps {
	data?: any
	sections?: any[]
}

export default function Navigation({ sections = [], data = {} }: NavigationProps) {
	const navigate = useNavigate()

	useEffect(() => {
		Logger.log('[Navigation] data', data)
	}, [data])

	const { useOnboardingState, goBackward } = useContext(OnboardingContext)
	const { activeSection, activeSegment, completedSections = [] }: any = useOnboardingState()

	const steps = useOnboardingSteps()

	const backDisabled = useMemo(() => {
		return activeSection === 0 && activeSegment === 0
	}, [activeSection, activeSegment])

	/**
	 * Handle the section click
	 * @param {string} section
	 * @returns {void}
	 */
	const handleSectionClick = (section: string): void => {
		// check to see if the section is completed
		const isCompleted = completedSections.includes(section)
		// if the section is not completed and it's not the checkout section, don't allow
		if (!isCompleted && section !== 'checkout') {
			return
			// if the section is the checkout section and the user hasn't completed all the sections, don't allow
		} else if (section === 'checkout' && completedSections.length < 3) {
			return
		}
		// find the section group
		const sectionGroup = steps.find((step: any) => step.name === section)
		// if there are no segments, return
		if (!sectionGroup?.segments) return
		// get the first segment
		const firstSegment = sectionGroup.segments[0]
		// compose the uri, if it's a function, call it with the data else use the uri
		const uri = typeof firstSegment.uri === 'function' ? firstSegment.uri(data) : firstSegment.uri
		// finally, navigate to the uri
		navigate(uri as string)
	}

	return (
		<Box sx={styles.root}>
			{/* <Box>
				<Button sx={styles.back} disabled={backDisabled} onClick={() => goBackward()}>
					&lt; back
				</Button>
			</Box> */}
			<Box sx={styles.items}>
				{sections.map((section: any, idx: number) => (
					<Section
						key={section.name}
						index={idx}
						{...section}
						last={idx === sections.length - 1}
						active={idx === activeSection || !!completedSections.includes(section.name)}
						onClick={() => handleSectionClick(section.name)}
					/>
				))}
			</Box>
		</Box>
	)
}

const styles = {
	root: {
		position: 'relative',
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: {
			xs: 8,
			md: 6
		},
		pt: 3
	},
	back: {
		position: {
			xs: 'absolute',
			md: 'relative'
		},
		textTransform: 'none',
		color: {
			xs: '#000',
			md: '#fff'
		},
		'&.Mui-disabled': {
			color: {
				xs: 'rgba(0, 0, 0, 0.5)',
				md: 'rgba(255, 255, 255, 0.5)'
			}
		}
	},
	items: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flex: 1
	}
}
